import aemMock from "../../public/aemMock.json";
import FrenchContent from '../../locales/fr/translation.json'
const { VITE_CONTENT_SERVICE_BASE_URL, VITE_CONTENT_SERVICE_ROUTING_KEY } = window.__conf__;
import type { AemContent } from "#types/components/core.type.ts";

export const fetchAemContent = async (language = 'en-us', mockData: AemContent = language === 'fr-ca' ? FrenchContent : aemMock) => {
    try {   
        const aemBaseURL = VITE_CONTENT_SERVICE_BASE_URL
        const url = new URL(aemBaseURL);
        url.searchParams.set("locale", language);
        const response = await fetch(url.toString(), {
            method: "GET",
            mode: "cors",
            headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "routingKey": VITE_CONTENT_SERVICE_ROUTING_KEY
            }
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch AEM content":${response.statusText}`)
        }
        const aemData = await response.json();
        if (!response.ok || !aemData || Object.keys(aemData).length === 0) {
            console.error(`Failed to fetch AEM content":${response.statusText || "Empty response "}`)
            return mockData;
        }
        const mergedData = {
            ...aemData,
            header: {
                primaryLogoImage: aemData?.header?.primaryLogoImage,
                primaryLogoImageAltText: mockData?.header?.primaryLogoImageAltText,
                primaryButton: {
                    label: mockData?.header?.primaryButton?.label,
                    displayIcon: mockData?.header?.primaryButton?.displayIcon,
                },
                support: mockData?.header?.support,
                navs: mockData?.header?.navs
            },
            footer: {
                ...aemData?.footer,
                footerLinks: mockData?.footer?.footerLinks,
                copyRight: mockData?.footer?.copyRight,
                businessAddress: aemData?.footer?.businessAddress
            },
            valuePage: {
                headingBanner: {
                    ribbonHeading: aemData?.valuePage?.headingBanner?.ribbonHeading,
                    ribbonHeadingBodyCopy: aemData?.valuePage?.headingBanner?.ribbonHeadingBodyCopy,
                    image1: aemData?.valuePage?.headingBanner?.image1,
                    image1_alt: mockData?.valuePage?.headingBanner?.image1_alt,
                    primaryButton: {
                        label: mockData?.valuePage?.headingBanner?.primaryButton?.label,
                        url: mockData?.valuePage?.headingBanner?.primaryButton?.url,
                    },
                    secondaryButton: {
                        label: mockData?.valuePage?.headingBanner?.secondaryButton?.label,
                        url: mockData?.valuePage?.headingBanner?.secondaryButton?.url,
                        target: mockData?.valuePage?.headingBanner?.secondaryButton?.target,
                    }
                },
                valuePropFeatures: {
                    featureListTitle: aemData?.valuePage?.valuePropFeatures?.featureListTitle,
                    featureList: aemData?.valuePage?.valuePropFeatures?.featureList
                 },
                faq: {
                    heading: aemData?.valuePage?.faq?.heading,
                    questionAnswerPairs: aemData?.valuePage?.faq?.questionAnswerPairs
            }
        }
    }
        return mergedData;

    }
    catch (error) {
        return language === 'fr-ca' ? FrenchContent : mockData;
    }
}
